/** Import modules */

import { useTranslation }   from "react-i18next";

import { useQuery }         from "@apollo/client";

import { Helmet }           from "react-helmet-async";

import {
    hreflangLinks,
    localizedAbsoluteUrl,
    localizedValue,
    normalizeLanguage
}                           from "../../Components/SEO/localizedMeta";

import { FrontEndPages }    from "../../Queries/Policies";

import cookies              from "js-cookie";

import parse               from "html-react-parser";

import ComponentLoader      from "../../Components/Layout/Loaders/Loader";

/** Import components */

import Breadcrumbs          from "../../Components/Layout/Header/Breadcrumbs";

import ContentsLayout       from "../../Components/Contents/Layout";

/**
 * 
 * @returns Delivery page
 * 
 */

const Delivery = () => { const { t, i18n } = useTranslation (),

    currentLanguage = normalizeLanguage(i18n?.resolvedLanguage || i18n?.language),

    canonicalHref = localizedAbsoluteUrl("/content/delivery", currentLanguage),

    alternateLinks = hreflangLinks("/content/delivery"),

    pageDescription = localizedValue({
        lv: "Piegādes informācija Tireshop.lv: piegādes veidi, termiņi un izmaksas riepām, diskiem un akumulatoriem visā Latvijā. Izvēlies sev ērtāko saņemšanas risinājumu.",
        en: "Delivery information at Tireshop.lv: methods, timing, and costs for tires, rims, and batteries across Latvia. Choose the most convenient option for you.",
        ru: "Информация о доставке в Tireshop.lv: способы, сроки и стоимость доставки шин, дисков и аккумуляторов по всей Латвии. Выберите удобный вариант получения."
    }, currentLanguage),

    { data, loading } = useQuery ( FrontEndPages, { variables: { pageType: "delivery", language: cookies.get ( 'i18next' ) } } );

    /** Render component */

    return ( <div className="container max-content-width">

        <Helmet>

            <title>{ `Tireshop.lv | ${ t ( "delivery_information" ) }` }</title>

            <meta
                name="description"
                content={ pageDescription }
            />

            <link rel="canonical" href={ canonicalHref } />

            { alternateLinks.map((item) => (
                <link
                    key={ item.hreflang }
                    rel="alternate"
                    hrefLang={ item.hreflang }
                    href={ item.href }
                />
            )) }

        </Helmet>

        <Breadcrumbs collection={ [

            { name: t ( "delivery_information" ), URI: "/content/delivery" }

        ] } />

        <ContentsLayout title={ t ( "delivery_information" ) }>

            { 

                loading ? <ComponentLoader /> :

                    data?.frontendPages?.edges[0]?.node?.content ?
            
                        parse ( data.frontendPages.edges[0].node.content ) :

                        <p>Unable to retrive data.</p>
                
            }
            
        </ContentsLayout>
        
    </div> );

}

/** Export component */
 
export default Delivery;
